import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'

import Admin from '@/layouts/Admin'
import Guest from '@/layouts/Guest'

var jwtDecode = require('jwt-decode')

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('@/views/guest/Home'),
            redirect: '/login',
            meta: { layout: Guest }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/guest/Authorization'),
            meta: { layout: Guest }
        },

        //Admin                
        {
            path: '/admin',
            name: 'admin',
            component: () => import('@/views/admin/Layout'),
            redirect: 'admin/addresses',
            meta: { layout: Admin, is_auth: true },
            children: [
                {
                    path: 'home',
                    name: 'admin-home',
                    component: () => import('@/views/admin/Home'),
                    meta: { layout: Admin, name: 'главная', is_auth: true }
                },                
                {
                    path: 'addresses',
                    name: 'admin-addresses',
                    component: () => import('@/views/admin/Addresses'),
                    meta: { layout: Admin, name: 'адреса', is_auth: true }
                },                 
                {
                    path: 'address/:id',
                    name: 'admin-address-item',
                    component: () => import('@/views/admin/addresses/SingleAddress'),
                    meta: { layout: Admin, name: 'адрес', is_auth: true },
                    children: [
                        {
                            path: 'view-all',
                            name: 'admin-address-item-view-all',
                            component: () => import('@/views/admin/addresses/SingleAddressViewAll'),
                            meta: { layout: Admin, name: 'просмотр-адреса', is_auth: true }
                        },                
                        {
                            path: 'schedule',
                            name: 'admin-address-item-schedule',
                            component: () => import('@/views/admin/addresses/SingleAddressSchedule'),
                            meta: { layout: Admin, name: 'просмотр-графика-проверок-адреса', is_auth: true }
                        },                
                        {
                            path: 'edit',
                            name: 'admin-address-item-edit',
                            component: () => import('@/views/admin/addresses/SingleAddressEdit'),
                            meta: { layout: Admin, name: 'редактировать-адрес', is_auth: true }
                        }                 
                    ]
                },                 
                {
                    path: 'shelters',
                    meta: { layout: Admin, is_auth: true }
                },                 
                {
                    path: 'shelter/:id',
                    name: 'admin-shelter-item',
                    component: () => import('@/views/admin/addresses/SingleAddressViewShelter'),
                    meta: { layout: Admin, name: 'помещение', is_auth: true },
                    children: [
                        {
                            path: 'edit',
                            name: 'single-shelter-edit',
                            component: () => import('@/views/admin/shelters/SingleShelter'),
                            meta: { layout: Admin, name: 'редактирование-помещения', is_auth: true },
                        },
                        {
                            path: 'schedule',
                            name: 'single-shelter-schedule',
                            component: () => import('@/views/admin/shelters/SingleShelterSchedule'),
                            meta: { layout: Admin, name: 'график-проверок-помещения', is_auth: true },
                        }
                    ]
                },                 
                {
                    path: 'add-address',
                    name: 'admin-add-addresses',
                    component: () => import('@/views/admin/addresses/AddAddress'),
                    meta: { layout: Admin, name: 'добавление адреса', is_auth: true }
                },
                {
                    path: 'checkups',
                    name: 'admin-checkups',
                    component: () => import('@/views/admin/Checkups'),
                    meta: { layout: Admin, name: 'проверки', is_auth: true },
                    children: [
                        {
                            path: 'schedule',
                            name: 'schedule',
                            component: () => import('@/views/admin/checkups/CheckupsSchedule'),
                            meta: { layout: Admin, name: 'график проверок', is_auth: true }
                        },
                        {
                            path: 'new',
                            name: 'new-checkups',
                            component: () => import('@/views/admin/checkups/CheckupsNew'),
                            meta: { layout: Admin, name: 'список проверок', is_auth: true }
                        }
                    ]
                },
                {
                    path: 'reports',
                    name: 'admin-reports',
                    component: () => import('@/views/admin/Reports'),
                    meta: { layout: Admin, name: 'отчеты', is_auth: true }
                },
                {
                    path: 'staff',
                    name: 'admin-staff',
                    component: () => import('@/views/admin/Staff'),
                    meta: { layout: Admin, name: 'сотрудники', is_auth: true },
                    children: [
                        {
                            path: 'staff-list',
                            name: 'staff-list',
                            component: () => import('@/views/admin/staff/StaffList'),
                            meta: { layout: Admin, name: 'список сотрудников', is_auth: true }
                        }
                    ]
                },
                {
                    path: 'staff/:id',
                    name: 'admin-staff-single',
                    component: () => import('@/views/admin/staff/StaffSingle'),
                    meta: { layout: Admin, name: 'информация о сотруднике', is_auth: true },
                    children: [
                        {
                            path: 'checkups',
                            name: 'staff-member-checkups',
                            component: () => import('@/views/admin/staff/StaffSingleCheckups'),
                            meta: { layout: Admin, name: 'список проверок сотрудника', is_auth: true }
                        },
                        {
                            path: 'info',
                            name: 'staf-memberf-info',
                            component: () => import('@/views/admin/staff/StaffSingleInfo'),
                            meta: { layout: Admin, name: 'данные сотрудника', is_auth: true, is_admin: true, is_self: true }
                        }
                    ]
                },
                {
                    path: 'users',
                    name: 'admin-users',
                    component: () => import('@/views/admin/Users'),
                    meta: { layout: Admin, name: 'пользователи', is_auth: true },
                    children: [
                        {
                            path: 'users-list',
                            name: 'users-list',
                            component: () => import('@/views/admin/users/UsersList'),
                            meta: { layout: Admin, name: 'список пользователей', is_auth: true }
                        }
                    ]
                },
                {
                    path: 'service-entity',
                    name: 'admin-service-entity',
                    component: () => import('@/views/admin/ServiceEntity'),
                    meta: { layout: Admin, name: 'юридические лица', is_auth: true },
                    children: [
                        {
                            path: 'list',
                            name: 'service-entity',
                            component: () => import('@/views/admin/service-entity/ServiceEntityList'),
                            meta: { layout: Admin, name: 'список юридических лиц', is_auth: true }
                        }
                    ]
                },
                {
                    path: 'service-entity/:id',
                    name: 'service-entity-single',
                    component: () => import('@/views/admin/service-entity/ServiceEntitySingle'),
                    meta: { layout: Admin, name: 'юридическое лицо', is_auth: true },
                    children: [
                        {
                            path: 'info',
                            name: 'service-entity-single-info',
                            component: () => import('@/views/admin/service-entity/ServiceEntitySingleInfo'),
                            meta: { layout: Admin, name: 'юридическое лицо подробное информация', is_auth: true }
                        }
                    ]
                },
                {
                    path: 'certificate',
                    name: 'certificate',
                    component: () => import('@/views/admin/certificate/Certificate'),
                    props: true,
                    meta: { layout: Admin, name: 'акт проверки', is_auth: true }
                }
            ]
        },
        {
            path: '*',
            name: '404',
            component: () => import('@/views/404.vue')
        }
    ],
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
});

router.beforeEach ((to, from, next) => {
    //Получем ширину каждой страницы приложения
    store.dispatch('responsiveScreenWidth', document.documentElement.clientWidth)
    
    if (to.meta.is_auth) {
        try {
            if (!localStorage.getItem('token'))
            throw new Error('Unauthorized. No token.')

            if (!store.dispatch('authUseToken'))
            throw new Error('Unauthorized. Token broken.')
            
            // console.log(to.params.id)
            // console.log(store.getters['authUserId'])
            
            if (to.meta.is_admin) {
                try {
                    if (store.getters['authRole'].indexOf('ADMIN') > -1 || to.params.id === store.getters['authUserId']) next()
                    else throw new Error('Недостаточно прав')
                } catch (e) {
                    console.log('Permissions error: ' + e)
                    location.assign('/login')
                }
            }
        } catch (e) {
            console.log('Authorization error: ' + e)
            location.assign('/login')
        }
    }
    
    

    next()
})

export default router